// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__7CwLF","iconLink":"styles_iconLink__6mE1D","iconSearch":"styles_iconSearch__V_LXE","navLinks":"styles_navLinks__bNU8D"};